/**
 * YouTube thumbnail resolution for gallery media.
 *
 * Video media items store a YouTube page URL (watch, youtu.be, embed, or
 * shorts) in `url`/`thumbnailUrl`. Those are HTML pages, not images, so
 * rendering them through `next/image` fails. This module extracts the video id
 * and maps it to the `img.youtube.com` still frame that can actually be
 * rendered as an image.
 *
 * Copyright (c) SRAC. Use of this file is governed by the LICENSE file in the
 * repository root.
 */

const YOUTUBE_ID_PATTERNS = [
  /(?:youtube\.com\/watch\?(?:.*&)?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{6,})/,
];

/**
 * Converts a YouTube page URL into an image URL usable by `next/image`.
 *
 * @param url - Any URL. Non-YouTube URLs are returned unchanged.
 * @returns The `img.youtube.com` thumbnail for a recognised YouTube URL,
 *          otherwise the original `url`.
 */
export function resolveThumbnailUrl(url: string): string {
  for (const pattern of YOUTUBE_ID_PATTERNS) {
    const match = url.match(pattern);
    if (match) {
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    }
  }
  return url;
}
